import styled from 'styled-components';
import { generateContentIconStyle } from '../../icons';
import Checkmark from './Checkmark.svg';
import CheckmarkDisabled from './Checkmark-disabled.svg';

export const InputWrapper = styled.div`
  height: 28px;
  display: flex;
  align-items: center;
  position: relative;
`;

export const Label = styled.label`
  ${props => props.theme.typography.body}
  margin-left: ${props => props.theme.spacing(7)};
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  white-space: nowrap;
`;

export const Input = styled.input`
  ${props => props.theme.visuallyHidden}

  + label {
    display: block;
    cursor: pointer;
    padding-left: ${props => props.theme.spacing(2)};

    &::before {
      content: ' ';
      border-radius: 5px;
      border: 1px solid ${props => props.theme.colors.border.dark};
      background-color: ${({ theme }) => theme.colors.background.lightest};
      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      visibility: visible;
    }
  }
  &:checked + label::before {
    align-items: center;
    background: ${props => props.theme.colors.secondary.egg};
    border: 1px solid ${props => props.theme.colors.secondary.egg};
    content: url(${Checkmark.src});
    color: ${props => props.theme.colors.text.primary};
    display: flex;
    justify-content: center;
  }

  &:disabled + label {
    color: ${props => props.theme.colors.text.tertiary};
    &::before {
      background: ${props => props.theme.colors.background.disabled};
      border: 1px solid ${props => props.theme.colors.background.disabled};
    }
  }

  &:focus + label::before,
  &:focus:checked + label::before {
    border: 2px solid ${props => props.theme.colors.hero.spinach};
    margin: -1px;
  }

  &:disabled:checked + label::before {
    content: url(${CheckmarkDisabled.src});
    background: ${props => props.theme.colors.background.disabled};
    border: 1px solid ${props => props.theme.colors.background.disabled};
  }

  &:hover:enabled + label::before,
  &:hover:enabled:checked + label::before {
    border: 2px solid ${props => props.theme.colors.hero.spinach};
    margin: -1px;
  }
`;

export const RoundedCheckboxLabel = styled.label`
  align-items: center;
  background: ${({ checked, unavailable, theme }) => {
    return unavailable
      ? 'transparent'
      : checked
      ? theme.colors.secondary.egg
      : theme.colors.background.base;
  }};
  border-radius: 200px;
  border: 1px solid
    ${props =>
      props.unavailable ? 'transparent' : props.theme.colors.border.dark};
  display: grid;
  grid-template-columns: 30px 1fr;
  height: 62px;
  padding: ${props => props.theme.spacing(4)};
  text-align: center;

  ${({ theme }) => theme.typography.body}

  &:hover,
  &:focus-within {
    cursor: ${props => (props.unavailable ? 'not-allowed' : 'pointer')};
    border: 2px solid
      ${props =>
        props.unavailable ? 'transparent' : props.theme.colors.hero.spinach};
    margin: 0 -1px;
  }

  &::before {
    ${props =>
      props.checked
        ? generateContentIconStyle('radiobox-marked')
        : generateContentIconStyle('radiobox-blank')};
    ${props => props.unavailable && generateContentIconStyle('close')};
    width: 20px;
    height: 20px;
    background-color: ${props => props.theme.colors.border.dark};
  }
`;
